import * as React from 'react';
import PropTypes from 'prop-types';
var SvgSportsWindsurfNormalMedium = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M31.57 28.08a.52.52 0 00-.37-.16H20c3.71-13.7-.27-23.07-3-27.46a.48.48 0 00-.31-.23.54.54 0 00-.39.08l-6.19 4.1a.45.45 0 00-.2.28L5.12 21.55a.5.5 0 00.23.56 31.33 31.33 0 0014.16 3.55c-.16.74-.36 1.5-.57 2.26H2.15A1.08 1.08 0 001.08 29v1.5a1.07 1.07 0 001.07 1.08h24.47c4.88 0 5.08-3.1 5.08-3.13a.5.5 0 00-.13-.37zM6.19 21.43l4.59-16.29 5.6-3.71c2.43 4.07 5.58 12 3.34 23.24a31.89 31.89 0 01-13.53-3.24zm20.43 9.15H2.15a.07.07 0 01-.07-.08V29a.08.08 0 01.07-.08h28.4c-.31.65-1.23 1.66-3.93 1.66z"
  }));
});
SvgSportsWindsurfNormalMedium.defaultProps = {
  height: 32,
  width: 32
};
SvgSportsWindsurfNormalMedium.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgSportsWindsurfNormalMedium;